<template>
  <div>
    <LayoutMypageTy2>
      <template #contents>
        <LinkCompanyfollow class="detail" :logo="profile.logoImageId">
          {{ profile.companyName }}
        </LinkCompanyfollow>
        <div class="column_list_item ty2">
          <a class="link_img">
            <span>
              <skeleton-box v-if="!profile.businessImageId" />
              <img v-else :src="thumbnailImageWithOptions(profile.businessImageId, { w: 588 })" alt="">
            </span>
          </a>
          <div class="text_box">
            <LinkCompanyText class="mypage_2" :logo="profile.logoImageId">
              <template #companyName>
                {{ profile.companyName }}
              </template>
            </LinkCompanyText>
            <div class="btn_fly_2">
              <div class="check_text ">
                <label><input type="checkbox" :checked="isFollowYn" @change="handleUpdateFollow"><span>팔로우</span><span
                  class="toggle"
                >팔로잉</span></label>
              </div>
              <button type="button" class="btn_share" @click="handleClickShare">
                <i class="icon_font_share" />
              </button>
            </div>

            <div class="user_counting ty2">
              <div>
                <strong class="font_p4">올린 콘텐츠</strong>
                <span class="font_h2">{{ convertComma(contentsCnt) }}</span>
              </div>
              <div>
                <strong class="font_p4">팔로워 수</strong>
                <span class="font_h2">{{ convertComma(followCnt) }}</span>
              </div>
            </div>

            <p class="text font_p2">
              {{ profile.introduceContents }}
            </p>
          </div>
        </div>

        <div class="more_box dropdown" :class="{ open: isToggle }">
          <button type="button" class="more_btn icon_font" @click="() => isToggle = !isToggle">
            더보기
          </button>
          <div class="text_info_01 ty2">
            <dl v-if="profile.ceoName">
              <dt>대표자</dt>
              <dd>{{ ceoName }}</dd>
            </dl>
            <dl v-if="profile.establishmentDt">
              <dt>설립일</dt>
              <dd>{{ establishmentDt }}</dd>
            </dl>
            <dl v-if="profile.listedCompanyName">
              <dt>상장 여부</dt>
              <dd>{{ listedCompanyName }}</dd>
            </dl>
            <dl v-if="profile.companySizeName">
              <dt>기업 규모</dt>
              <dd>{{ companySizeName }}</dd>
            </dl>
            <dl v-if="profile.companyLocationName">
              <dt>소재지</dt>
              <dd>{{ companyLocationName }}</dd>
            </dl>
            <dl v-if="profile.industryType">
              <dt>업종/업태</dt>
              <dd>{{ industryType }}</dd>
            </dl>
            <dl v-if="profile.mainService">
              <dt>주요 상품<br>/서비스</dt>
              <dd>{{ mainService }}</dd>
            </dl>
            <dl v-if="profile.employmentPeople">
              <dt>고용 인원</dt>
              <dd>{{ employmentPeopleCnt }}</dd>
            </dl>
            <dl v-if="profile.salesAmt">
              <dt>연 매출</dt>
              <dd>{{ salesAmt }}</dd>
            </dl>
            <dl v-if="profile.profitAmt">
              <dt>영업 이익</dt>
              <dd>{{ profitAmt }}</dd>
            </dl>
            <dl v-if="profile.homeUrl" class="w100">
              <dt>홈페이지</dt>
              <dd v-if="profile.homeUrl">
                <a :href="profile.homeUrl" class="link_line">바로가기</a>
              </dd>
              <dd v-else>
                -
              </dd>
            </dl>
          </div>
        </div>

        <BusinessBlogFrom
          v-if="categoryList.length > 0"
          tab-class="mt40 mb0"
          :api="BLOG_LIST_API"
          :category-list="categoryList"
          type="card_ty7"
          :business-seq="profile.businessSeq"
        />
        <p v-else class="text_none font_p2 mt60 m_mt36">
          콘텐츠가 없습니다.
        </p>
      </template>
    </LayoutMypageTy2>
  </div>
</template>
<script setup lang="ts">
import type { ICategory } from '~/modules/category/types/model'
import BusinessService from '~/modules/business/services/business'
import type { IBusinessParameter, IBusinessProfile } from '~/modules/business/types/business'
import useContentInterest from '~/modules/content/composables/interest'
import routePath from '~/config/route'
import useContentNavigator from '~/modules/content/composables/navigate'
import { useImagesThumbnail } from '~/composables/images/thumbnail'
// definePageMeta({
//   layout: 'empty'
// })
const { thumbnailImageWithOptions } = useImagesThumbnail()
const { follow, share, checkedLogin } = useContentInterest()
const { navigateToInterestFollowing } = useContentNavigator()
const { navigateToLogin } = useMemberNavigator()
const snackbar: any = inject('snackbar')
const confirm: any = inject('confirm')
const isToggle = ref<boolean>(false)
// const categoryService = new CategoryService()
const businessService = new BusinessService()
const route = useRoute()
const BLOG_LIST_API = '/board/v1/blog/list'
const categoryList = ref<ICategory[]>([])
const isFollowYn = ref<boolean>(false)
const followCnt = ref<number>(0)
const contentsCnt = ref<number>(0)
const isLoading = ref<boolean>(false)
const profile = ref<IBusinessProfile>({
  businessSeq: 0,
  businessId: '',
  companyName: '',
  businessNumber: '',
  ceoName: '',
  establishmentDt: '',
  listedCompany: '',
  listedCompanyName: '',
  companySize: '',
  companySizeName: '',
  companyLocation: '',
  companyLocationName: '',
  industryType: '',
  homeUrl: '',
  mainService: '',
  logoImageId: '',
  logoImageUrl: '',
  businessImageId: '',
  businessImageUrl: '',
  introduceContents: '',
  employmentPeople: 0,
  employmentYear: '',
  salesAmt: 0,
  salesYear: '',
  profitAmt: 0,
  profitYear: '',
  masterYn: ''
})
const config = useRuntimeConfig()

onBeforeMount(() => init())
onMounted(() => hideQuickButton())
const hideQuickButton = () => {
  const headerEl = document.querySelector('#header')
  const footerEl = document.querySelector('#footer')
  if (headerEl) {
    headerEl.classList.add('detail')
  }
  if (footerEl) {
    footerEl.classList.add('detail')
  }
}
const searchParam = reactive<IBusinessParameter>({
  businessSeq: 0
})

const init = async () => {
  isLoading.value = true
  if (isNaN(Number(route.params.id))) {
    searchParam.businessId = route.params.id as string
  } else {
    searchParam.businessSeq = Number(route.params.id)
  }

  if (route.query.post) {
    searchParam.postSeq = Number(route.query.post)
  }

  try {
    const business = await businessService.getBusinessProfile(searchParam)
    profile.value = business.business
    isFollowYn.value = business.followYn === 'Y'
    followCnt.value = business.followerCnt ?? 0
    contentsCnt.value = business.contentsCnt ?? 0
    categoryList.value = business.categoryList
    isLoading.value = false

    useHead({
      title: `${business.business.companyName} - 오운드 OUND`,
      meta: [
        { hid: 'og:title', property: 'og:title', content: `${business.business.companyName} - 오운드 OUND` },
        { hid: 'description', property: 'description', content: business.business.introduceContents },
        { hid: 'og:description', property: 'og:description', content: business.business.introduceContents }
      ]
    })
  } catch (err: any) {
    throw createError({ statusCode: err.code, message: err.message, fatal: true })
  }
}
/**
 * 대표자
 */
const ceoName = computed(() => {
  return profile.value.ceoName ?? '-'
})

/**
 * 설립일
 */
const establishmentDt = computed(() => {
  if (profile.value.establishmentDt) {
    return profile.value.establishmentDt.replaceAll('-', '.')
  }
  return '-'
})
/**
 * 주요 상품/서비스
 */
const mainService = computed(() => {
  return profile.value.mainService ?? '-'
})

/**
 * 상장 여부
 */
const listedCompanyName = computed(() => {
  return profile.value.listedCompanyName ?? '-'
})

/**
 * 기업 규모
 */
const companySizeName = computed(() => {
  return profile.value.companySizeName ?? '-'
})

/**
 * 소재지
 */
const companyLocationName = computed(() => {
  return profile.value.companyLocationName ?? '-'
})

/**
 * 업종형태
 */
const industryType = computed(() => {
  return profile.value.industryType ?? '-'
})

/**
 * 고용 인원
 */
const employmentPeopleCnt = computed(() => {
  const employmentPeople = profile.value.employmentPeople ?? 0
  const employmentYear = profile.value.employmentYear ?? ''

  if (employmentPeople === 0) {
    return '-'
  }
  if (employmentYear === '') {
    return `${convertComma(employmentPeople)}명`
  }
  return `${convertComma(employmentPeople)}명(${employmentYear})`
})

/**
 * 연 매출
 */
const profitAmt = computed(() => {
  const profitAmt = profile.value.profitAmt ?? 0
  const profitYear = profile.value.profitYear ?? ''

  if (profitAmt === 0) {
    return '-'
  }
  if (profitYear === '') {
    return `${convertComma(profitAmt)}천원`
  }
  return `${convertComma(profitAmt)}천원(${profitYear})`
})

/**
 * 영업 이익
 */
const salesAmt = computed(() => {
  const salesAmt = profile.value.salesAmt ?? 0
  const salesYear = profile.value.salesYear ?? ''

  if (salesAmt === 0) {
    return '-'
  }
  if (salesYear === '') {
    return `${convertComma(salesAmt)}천원`
  }
  return `${convertComma(salesAmt)}천원(${salesYear})`
})

/**
 * 공유하기
 */
const handleClickShare = async () => {
  if (profile.value) {
    const config = useRuntimeConfig()
    const host = config.public.SHOP_HOST as string
    const url = `${host}${routePath.BUSINESS_PROFILE}/${profile.value.businessId}`
    await share(url, profile.value.companyName ?? '')
    // await shareByAnalytics(post.value.postSeq)
  }
}

/**
 * 팔로우 변경
 */
const handleUpdateFollow = (e: Event) => {
  const target = e.target as HTMLInputElement
  checkedLogin(
    async () => {
      await follow(profile.value.businessSeq, target.checked ? 'Y' : 'N', searchParam.postSeq)

      if (target.checked) {
        snackbar.info('팔로잉 목록에 추가되었습니다', '팔로잉 목록 보기', () => {
          navigateToInterestFollowing()
        })
      }
    },
    () => {
      isFollowYn.value = false
      target.checked = false
      confirm.open({
        title: '로그인이 필요합니다<br />로그인 페이지로 이동할까요?',
        confirm: () => {
          navigateToLogin({ query: { redirectUrl: `${config.public.SHOP_HOST}${route.fullPath}` } })
        }
      })
    }
  )
}

</script>
<style scoped>
.column_list_item.ty2 .link_img span {
  display: block;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  height: 306px;
  position: relative;
}

.column_list_item.ty2 .link_img img {
  position: absolute;
  top: -100%;
  right: -100%;
  bottom: -100%;
  left: -100%;
  width: 100%;
  height: auto;
  margin: auto;
}

.column_list_item.ty2 .text_box {
  border-radius: 0;
  border: none;
  border-top: none;
  padding: 40px 0 0;
  box-sizing: border-box;
  height: auto;
}

.column_list_item.ty2 .link_company_text + .font_p2 {
  margin-top: 16px;
}

.column_list_item.ty2 .text {
  display: block;
}

.mypage_in .link_company_follow.detail {
  display: none;
}

.btn_fly_2 {
  margin-top: -42px;
  display: flex;
  gap: 8px;
  z-index: 1;
  padding-bottom: 21px;
  justify-content: flex-end;
}

.btn_fly_2 .check_text {
  z-index: 1;
}

.btn_fly_2 .check_text span {
  height: 42px;
  line-height: 41px;
  width: 180px;
}

.btn_fly_2 .btn_share {
  width: 42px;
  height: 42px;
  border-color: var(--color-button-line-default);
}

.btn_fly_2 .btn_share .icon_font_share:before {
  color: var(--color-primary-10);
}

.user_counting.ty2 {
  background: var(--color-background-sub1);
  padding: 1.625rem 1.375rem 1.45rem;
  display: flex;
  gap: 24px;
  border-radius: 4px;
  margin: 16px 0;
}

.user_counting.ty2 div {
  text-align: center;
  color: var(--color-text-title);
  flex: 1 1;
}

.user_counting.ty2 strong {
  display: block;
  color: var(--color-text-title);
  letter-spacing: 0;
  font-weight: normal;
}

.user_counting.ty2 span {
  display: block;
  line-height: 100%;
}

.more_box {
  position: relative;
  width: 100%;
  margin-top: 16px;
}

.more_box .text_info_01 {
  display: none;
}

.more_box.open .text_info_01 {
  display: flex;
  margin-top: 16px;
}

.more_box .more_btn:before {
  content: "\e014";
  display: block;
  position: absolute;
  right: 8.7px;
  top: 6.7px;
  color: var(--color-text-sub);
  font-size: 11.17px;
  transform: rotate(180deg);
}

.more_box .more_btn {
  display: inline-block;
  width: 100%;
  padding: 0 30px 0 0;
  color: var(--color-sorting-default);
  font-size: var(--font-size-6);
  line-height: 1.5rem;
  height: 1.5rem;
  text-align: left;
  box-sizing: border-box;
  background: var(--color-background-default);
}

.more_box.open .more_btn:before {
  transform: rotate(0deg);
}

@media screen and (max-width: 768px) {
  .column_list_item.ty2 .link_img span {
    height: 174px;
  }

  .column_list_item.ty2 .text_box {
    padding: 30px 0 0;
  }

  .mypage_in .link_company_follow.detail {
    display: inline-block;
    position: fixed;
    top: 0;
    width: calc(100% - 100px);
    margin: 0;
    height: 55px;
    line-height: 55px;
    left: 50px;
    z-index: 100;
    text-align: center;
    background: var(--color-background-default);
    display: flex;
    justify-content: center;
  }

  .text_box .link_company_text.mypage_2 {
    display: none;
  }

  .text_box .btn_fly_2 {
    margin: 10px 0 0;
    padding: 0;
    gap: 17px;
  }

  .text_box .btn_fly_2 .check_text {
    width: 100%;
  }

  .text_box .btn_fly_2 .check_text span {
    width: 100%;
  }

  .text_box .btn_fly_2 .btn_share {
    width: 71px;
  }
}
</style>
